import React from 'react'


interface RadioProps extends React.AllHTMLAttributes<HTMLInputElement> {
    label: any,
    additionalText?: any,
    radiobuttonRef?: any
}

const CustomRadio: React.FC<RadioProps> = ({ label, onChange, name, value, checked, disabled, additionalText, radiobuttonRef, ...rest }: RadioProps) => {
    return (
        <>
            <label className="radio-label">
                <input
                    type="radio"
                    className={"radio-input"}
                    name={name}
                    value={value}
                    disabled={disabled}
                    checked={checked}
                    onChange={onChange}
                    ref={radiobuttonRef}
                    {...rest}
                />
                <span className="custom-radio" />
                <span className='radioLabel'>{label}</span>
                {additionalText}
            </label>
        </>
    )
}

export default CustomRadio